var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM16.5735 11.8121C15.0173 12.4594 11.907 13.7991 7.24269 15.8313C6.48527 16.1325 6.08851 16.4271 6.05239 16.7152C5.99134 17.2022 6.60111 17.3939 7.43146 17.655C7.54441 17.6905 7.66144 17.7273 7.78141 17.7663C8.59835 18.0319 9.69726 18.3425 10.2685 18.3549C10.7868 18.3661 11.3651 18.1524 12.0037 17.7139C16.3617 14.7722 18.6113 13.2852 18.7526 13.2532C18.8522 13.2306 18.9903 13.2021 19.0838 13.2853C19.1774 13.3684 19.1682 13.5259 19.1583 13.5682C19.0979 13.8257 16.7043 16.0509 15.4657 17.2025C15.0795 17.5615 14.8056 17.8162 14.7496 17.8743C14.6242 18.0046 14.4963 18.1279 14.3735 18.2463C13.6145 18.9779 13.0454 19.5266 14.405 20.4225C15.0583 20.8531 15.5812 21.2091 16.1027 21.5643C16.6724 21.9523 17.2405 22.3392 17.9756 22.821C18.1629 22.9438 18.3418 23.0713 18.516 23.1955C19.1789 23.6681 19.7745 24.0927 20.5103 24.025C20.9378 23.9857 21.3794 23.5836 21.6037 22.3846C22.1338 19.551 23.1757 13.4114 23.4165 10.8815C23.4375 10.6598 23.411 10.3761 23.3897 10.2516C23.3684 10.1271 23.3239 9.94964 23.162 9.8183C22.9703 9.66274 22.6743 9.62994 22.542 9.63227C21.9402 9.64288 21.0169 9.96392 16.5735 11.8121Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegramGradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99%",
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c6593f3b.svg";
export { ForwardRef as ReactComponent };